/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `Automotive` - Automotive
 * * `Business/Professional Services` - Business/Professional Services
 * * `Energy` - Energy
 * * `Finance` - Finance
 * * `Government` - Government
 * * `Healthcare` - Healthcare
 * * `Manufacturing/Engineering` - Manufacturing/Engineering
 * * `Media/Entertainment/Sports/Arts` - Media/Entertainment/Sports/Arts
 * * `NGO/Non-Profit/Social Enterprise` - NGO/Non-Profit/Social Enterprise
 * * `Religion` - Religion
 * * `Research/Education` - Research/Education
 * * `Retail/Real Estate/Travel` - Retail/Real Estate/Travel
 * * `Technology` - Technology
 * * `Other` - Other
 * @export
 */
export const IndustryEnum = {
  automotive: 'Automotive',
  businessProfessionalServices: 'Business/Professional Services',
  energy: 'Energy',
  finance: 'Finance',
  government: 'Government',
  healthcare: 'Healthcare',
  manufacturingEngineering: 'Manufacturing/Engineering',
  mediaEntertainmentSportsArts: 'Media/Entertainment/Sports/Arts',
  ngoNonProfitSocialEnterprise: 'NGO/Non-Profit/Social Enterprise',
  religion: 'Religion',
  researchEducation: 'Research/Education',
  retailRealEstateTravel: 'Retail/Real Estate/Travel',
  technology: 'Technology',
  other: 'Other',
} as const;
export type IndustryEnum = (typeof IndustryEnum)[keyof typeof IndustryEnum];

export function instanceOfIndustryEnum(value: any): boolean {
  for (const key in IndustryEnum) {
    if (Object.prototype.hasOwnProperty.call(IndustryEnum, key)) {
      if ((IndustryEnum as Record<string, IndustryEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function IndustryEnumFromJSON(json: any): IndustryEnum {
  return IndustryEnumFromJSONTyped(json, false);
}

export function IndustryEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndustryEnum {
  return json as IndustryEnum;
}

export function IndustryEnumToJSON(value?: IndustryEnum | null): any {
  return value as any;
}
